<template>
    <layout-card
        :isCustomizable="settings.isCustomizable"
        :placeholder="placeholder"
        placeholderImg="/ressources/logged/img/dashboard/dashboard-marketing.svg"
        class="card-marketing_campaign"
        :error="error"
        :loading="loading"
        @hide-card="$emit('hide-card', 'marketing_campaign')"
        @refresh-card="fetchCard('marketing_campaign', {}, true)"
    >
        <!-- SLOTED TITLE -->
        <template #title>
            {{ name }}
            <span class="fs-3 regular gray-60 ml-2">{{
                $l10n.__('10 dernières campagnes envoyées')
            }}</span>
        </template>

        <!-- SLOTED ACTIONS -->
        <template #actions>
            <CompassIconButton v-if="settings.canCreate" icon="plus" onclick="Campaign.create()" />
        </template>

        <!-- SLOTED CONTENT -->
        <template #content>
            <div
                v-if="(cardData && cardData.length > 0) || (cardData && cardData.error)"
                onresize="resizeCard()"
                class="hp-10"
            >
                <div v-if="!cardData.error">
                    <el-table
                        ref="table"
                        :data="cardData"
                        headerCellClassName="grey semibold"
                        rowClassName="no-hover"
                        class="table-ellipsis"
                        height="100%"
                        stripe
                        style="width: 100%"
                    >
                        <el-table-column prop="name" width="250">
                            <template #default="scope">
                                <a id="link" :href="scope.row.link">
                                    <span class="gray-100 semibold">{{ scope.row.name }}</span>
                                    <p class="grey mt-1">
                                        {{
                                            $filters.dateFormatter(
                                                scope.row.date,
                                                'SLASHED_DATE_TIME',
                                            )
                                        }}
                                    </p>
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="recipients"
                            :label="$t.__('dashboard.cards.MarketingCampaignCard.recipients')"
                            headerAlign="right"
                            align="right"
                        >
                            <template #default="scope">
                                <p>{{ formatStats(scope.row.recipients) }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="open"
                            :label="$t.__('dashboard.cards.MarketingCampaignCard.opening')"
                            headerAlign="right"
                            align="right"
                        >
                            <template #default="scope">
                                <p>{{ $filters.numberFormat(scope.row.open) }}%</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="click"
                            :label="$t.__('dashboard.cards.MarketingCampaignCard.clics')"
                            headerAlign="right"
                            align="right"
                        >
                            <template #default="scope">
                                <p>{{ formatStats(scope.row.click) }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="unsub"
                            :label="$t.__('dashboard.cards.MarketingCampaignCard.unsubscribed')"
                            headerAlign="right"
                            align="right"
                        >
                            <template #default="scope">
                                <p>{{ $filters.numberFormat(scope.row.unsub) }}%</p>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </template>
    </layout-card>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import CardMixin from './CardMixin.js';
export default {
    components: {
        LayoutCard,
    },
    mixins: [CardMixin],
    computed: {
        placeholder() {
            return this.$l10n.__('Aucune campagne marketing à afficher');
        },
    },
    created() {
        window.EventBus.on('refresh_event', () => {
            this.fetchCard(this.type);
        });

        EventBus.on('doLayoutCard', () => {
            this.$refs.table.doLayout();
        });
    },
    methods: {
        formatStats(number) {
            const numformat = {
                ...App.numformat,
                ...{ decimals: ' ', precision: 0, currency: '' },
            };
            return NumberFormat.formatToDisplayWithCurrency(number, numformat);
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
@import '~@sellsy/styleguide/src/_mixins';

.card-marketing_campaign {
    .el-table__row--striped.no-hover:hover > td {
        background-color: #fafafa !important;
    }
    .no-hover:hover > td {
        background-color: transparent !important;
    }

    #link {
        &:hover {
            span {
                color: $primary-50 !important;
            }
        }
    }

    .el-table::before {
        background-color: transparent;
    }
}
</style>
